import {AudioRecorderProps} from '../components/audio-recorder';

export const getAudioRecorder =
  <T>(data: Omit<AudioRecorderProps<T>, 'type'>) =>
  (): AudioRecorderProps<T> =>
    ({
      ...data,
      type: 'audio-recorder',
    } as AudioRecorderProps<T>);
